import { Injectable } from '@angular/core';
import { NotificationMappingModel } from './models/notifications-center-mapping.model';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

export interface NotificationsCenterMappingState extends EntityState<NotificationMappingModel> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'notifications-center-mapping', idKey: 'loyaltyActionId' })
export class NotificationsCenterMappingStore extends EntityStore<NotificationsCenterMappingState> {
  constructor() {
    super();
  }
}
